export default __webpack_public_path__ + "static/media/arrow-right.9c158419.svg";